import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { isScreenShareParticipantById } from 'jitsi/base/participants/functions';
import { STATS_POPOVER_POSITION, THUMBNAIL_TYPE } from 'jitsi/filmstrip/constants';
import { getIndicatorsTooltipPosition } from 'jitsi/filmstrip/functions.web';
import PinnedIndicator from 'jitsi/filmstrip/components/web/PinnedIndicator';
import RaisedHandIndicator from 'jitsi/filmstrip/components/web/RaisedHandIndicator';
import StatusIndicators from 'jitsi/filmstrip/components/web/StatusIndicators';
import ConnectionIndicator from '../../connection-indicator/components/ConnectionIndicator';
import DisplayName from "jitsi/display-name/components/web/DisplayName";
import { isDisplayNameVisible, isNameReadOnly } from 'jitsi/base/config/functions.any';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        '& > *:not(:last-child)': {
            marginRight: '4px',
        },
    },
    nameContainer: {
        display: 'flex',
        flex: 1,
        color: theme.palette.iisightBlack,
        justifyContent: 'flex-end',
    },
    nameMobileWidth: {
        maxWidth: '100px',
    },
}));
const ThumbnailTopIndicators = ({ disableConnectionIndicator, isHovered, local, participantId, thumbnailType, indicatorsClassName, }) => {
    const { classes: styles, cx } = useStyles();
    const _isMobile = isMobileBrowser();
    const _indicatorIconSize = 16; // Default size
    const _connectionIndicatorAutoHideEnabled = Boolean(useSelector((state) => state['features/base/config'].connectionIndicators?.autoHide) ?? true);
    const _connectionIndicatorDisabled = _isMobile ||
        disableConnectionIndicator ||
        Boolean(useSelector((state) => state['features/base/config'].connectionIndicators?.disabled));
    const showConnectionIndicator = isHovered || !_connectionIndicatorAutoHideEnabled;
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    const _showDisplayName = useSelector(isDisplayNameVisible);
    const renderDisplayName = () => {
        const _allowEditing = !useSelector(isNameReadOnly);
        const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
        return (React.createElement("span", { className: `${styles.nameContainer} ${_isMobile ? styles.nameMobileWidth : ''}` },
            React.createElement(DisplayName, { allowEditing: local ? _allowEditing : false, displayNameSuffix: local ? _defaultLocalDisplayName : '', elementID: local ? 'localDisplayName' : `participant_${participantId}_name`, participantID: participantId, thumbnailType: thumbnailType })));
    };
    if (isVirtualScreenshareParticipant) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.container }, !_connectionIndicatorDisabled && (React.createElement(ConnectionIndicator, { alwaysVisible: showConnectionIndicator, enableStatsDisplay: true, iconSize: _indicatorIconSize, participantId: participantId, statsPopoverPosition: STATS_POPOVER_POSITION[thumbnailType] }))),
            renderDisplayName()));
    }
    const tooltipPosition = getIndicatorsTooltipPosition(thumbnailType);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement(PinnedIndicator, { iconSize: _indicatorIconSize, participantId: participantId, tooltipPosition: tooltipPosition }),
            !_connectionIndicatorDisabled && (React.createElement(ConnectionIndicator, { alwaysVisible: showConnectionIndicator, enableStatsDisplay: true, iconSize: _indicatorIconSize, participantId: participantId, statsPopoverPosition: STATS_POPOVER_POSITION[thumbnailType] })),
            React.createElement(RaisedHandIndicator, { iconSize: _indicatorIconSize, participantId: participantId, tooltipPosition: tooltipPosition }),
            thumbnailType !== THUMBNAIL_TYPE.TILE && (React.createElement("div", { className: cx(indicatorsClassName, 'top-indicators') },
                React.createElement(StatusIndicators, { participantID: participantId, screenshare: false })))),
        _showDisplayName && renderDisplayName()));
};
export default ThumbnailTopIndicators;
